/* istanbul ignore file */
// all requires actual browser
import { Editor } from "slate";
/**
 * check if mark icon should be active
 */
export var isMarkActive = function (editor, format) {
    var marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
/**
 * toggle mark on set of text
 */
export var toggleMark = function (editor, format) {
    var isActive = isMarkActive(editor, format);
    if (isActive) {
        Editor.removeMark(editor, format);
    }
    else {
        Editor.addMark(editor, format, true);
    }
};
